import * as React from 'react';

export function AssumeUserBanner(): React.ReactElement {
  return (
    <div data-testid="assume-user-banner" style={{ backgroundColor: '#800', color: '#fff', padding: '0.25rem 0.5rem' }}>
      You have assumed this user. Changes are not reversible, be careful.
      <a href="/auth/logout" style={{ color: '#fff', textDecoration: 'underline' }}>
        Unassume user
      </a>
    </div>
  );
}
